import { Title } from '@angular/platform-browser';
import {
  Component,
  OnInit,
  AfterViewInit,
  signal,
  effect,
  computed,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import { signOut } from 'aws-amplify/auth';
import { CredentialsService } from '@app/auth';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser, faSync } from '@fortawesome/free-solid-svg-icons';
import { BackendService } from '@shared/backend.service';
import { ProjectDetails } from '@shared/api_interfaces';
import { ProjectService } from './header.project.service';
import { RefreshDataService } from './refresh-data.service';
import { RefreshDataModalComponent } from './refresh-data-modal.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeaderComponent {
  faUser = faUser;
  faSync = faSync;
  user: any;
  access_token: any;
  public selectedProjectDetails = signal<ProjectDetails | null>(null);

  @ViewChild(RefreshDataModalComponent) refreshModal!: RefreshDataModalComponent;

  // Theme management with reactive signal
  private themeSignal = signal(document.documentElement.getAttribute('data-bs-theme') || 'light');

  currentTheme = computed(() => this.themeSignal());
  isDarkMode = computed(() => this.currentTheme() === 'dark');

  constructor(
    public projectService: ProjectService,
    private router: Router,
    private titleService: Title,
    public credentialsService: CredentialsService,
    private refreshDataService: RefreshDataService
  ) {
    effect(() => {
      this.projectService.fetchProjectDetails();
    });

    // Watch for theme changes
    effect(() => {
      const observer = new MutationObserver(() => {
        const currentTheme = document.documentElement.getAttribute('data-bs-theme') || 'light';
        this.themeSignal.set(currentTheme);
      });

      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-bs-theme'],
      });
    });
  }

  login() {}

  async logout() {
    await signOut();
    this.router.navigate(['/home'], { replaceUrl: true });
  }

  refreshData() {
    // Show the modal first
    this.refreshModal.show();

    // Start the refresh process
    this.refreshDataService.refreshData().subscribe({
      next: (response) => {
        // Modal will automatically update via the service subscription
        console.log('Data refresh completed:', response);
      },
      error: (error) => {
        // Modal will automatically show error via the service subscription
        console.error('Data refresh failed:', error);
      },
    });
  }
}
